<template>
	<div class="double-input" ref="doubleInput">
		<uInput></uInput>
		<span class="ledge">---</span>
		<uInput></uInput>
	</div>
</template>
<script>
	export default {
		name: 'doubleInput',
		mounted() {
			var $doubleInput = $(this.$refs.doubleInput);
			$doubleInput.children('.input-ctr').each(function() {
				var w = ($doubleInput.outerWidth() - $doubleInput.children('.ledge').outerWidth()-20)/2
				$(this).width(w);
//				console.log($doubleInput.children('.ledge').width())
			})

		}
	}
</script>



// WEBPACK FOOTER //
// src/components/uInput/doubleInput.vue